import React from 'react';
import PropTypes from 'prop-types';

const qualLeaderboardScoringInfo = (props) => {
    const showScoringInfoContent = () => {
        let isVisible = '';

        if (props.scoringInfoClassName) {
            isVisible = 'is-visible';
        }

        return isVisible;
    };

    return (
        <div className="qual-leaderboard__scoring-info-wrapper">
            <div className="qual-leaderboard__scoring-info-button-wrapper">
                <button
                    className="qual-leaderboard__scoring-info-button"
                    type="button"
                    onClick={() => props.clicked()}
                >
                    <div className="qual-leaderboard__scoring-info-text">
                        <span className="qual-leaderboard__scoring-info-text-word-m">Scoring </span>
                        <span className="qual-leaderboard__scoring-info-text-word-m">info</span>
                    </div>
                    <div className="qual-leaderboard__scoring-info-icon-wrapper">
                        <svg
                            className={`qual-leaderboard__scoring-info-icon icon
                                ${props.scoringInfoClassName ? 'is-open' : ''}`}
                            width="8"
                            height="8"
                            focusable="false"
                        >
                            <use xlinkHref="#icon-arrow-down">
                            </use>
                        </svg>
                    </div>
                </button>
            </div>
            <div className={`qual-leaderboard__scoring-info-content ${showScoringInfoContent()}`}>
                <ul className="qual-leaderboard__scoring-info-list-start">
                    <li className="qual-leaderboard__scoring-info-item-start">
                        Birdie
                    </li>
                    <li className="qual-leaderboard__scoring-info-item-start">
                        Eagle or better
                    </li>
                    <li className="qual-leaderboard__scoring-info-item-start">
                        Bogey or worse
                    </li>
                    <li className="qual-leaderboard__scoring-info-item-start">
                        Par
                    </li>
                </ul>
                <ul className="qual-leaderboard__scoring-info-list-end">
                    <li className="qual-leaderboard__scoring-info-item-end">
                        <span className="qual-leaderboard__scoring-info-item-end-title">Qualified</span>
                        <span className="qual-leaderboard__scoring-info-item-end-staus">Q</span>
                    </li>
                    <li className="qual-leaderboard__scoring-info-item-end">
                        <span className="qual-leaderboard__scoring-info-item-end-title">Reserve Place</span>
                        <span className="qual-leaderboard__scoring-info-item-end-staus">RES</span>
                    </li>
                    <li className="qual-leaderboard__scoring-info-item-end">
                        <span className="qual-leaderboard__scoring-info-item-end-title">No Return</span>
                        <span className="qual-leaderboard__scoring-info-item-end-staus">NR</span>
                    </li>
                    <li className="qual-leaderboard__scoring-info-item-end">
                        <span className="qual-leaderboard__scoring-info-item-end-title">Did Not Start</span>
                        <span className="qual-leaderboard__scoring-info-item-end-staus">DNS</span>
                    </li>
                    <li className="qual-leaderboard__scoring-info-item-end">
                        <span className="qual-leaderboard__scoring-info-item-end-title">No Show</span>
                        <span className="qual-leaderboard__scoring-info-item-end-staus">NS</span>
                    </li>
                    <li className="qual-leaderboard__scoring-info-item-end">
                        <span className="qual-leaderboard__scoring-info-item-end-title">Disqualified</span>
                        <span className="qual-leaderboard__scoring-info-item-end-staus">DQ</span>
                    </li>
                    <li className="qual-leaderboard__scoring-info-item-end">
                        <span className="qual-leaderboard__scoring-info-item-end-title">Retired</span>
                        <span className="qual-leaderboard__scoring-info-item-end-staus">RTD</span>
                    </li>
                    <li className="qual-leaderboard__scoring-info-item-end">
                        <span className="qual-leaderboard__scoring-info-item-end-title">Withdrawn</span>
                        <span className="qual-leaderboard__scoring-info-item-end-staus">WD</span>
                    </li>
                    <li className="qual-leaderboard__scoring-info-item-end">
                        <span className="qual-leaderboard__scoring-info-item-end-title is-own">* 10th Tee start</span>
                    </li>
                    <li className="qual-leaderboard__scoring-info-item-end">
                        <span className="qual-leaderboard__scoring-info-item-end-title is-own">(a) Amateur</span>
                    </li>
                    <li className="qual-leaderboard__scoring-info-item-end">
                        <span className="qual-leaderboard__scoring-info-item-end-title is-own">(a/r) Players Awaiting </span>
                    </li>
                    <li className="qual-leaderboard__scoring-info-item-end">
                        <span className="qual-leaderboard__scoring-info-item-end-title is-own">Amateur Reinstatement</span>
                    </li>
                </ul>
            </div>
        </div>
    );
};

qualLeaderboardScoringInfo.propTypes = {
    scoringInfoClassName: PropTypes.bool,
    clicked: PropTypes.func
};

export default qualLeaderboardScoringInfo;
